import React, { useEffect, useState } from "react";

import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import edit from "../../images/edit.svg";
import { UpdatePermissionModal } from "./adminComp/updatePermissionsModal";
import { useAlert } from "react-alert";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import copy from "copy-to-clipboard";
import { AddSummary } from "./adminComp/addSummaryModal";

function TradeSummary({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [signal, setSignal] = useState("");
  const [summary, setSummary] = useState("");

  const [permissionModal, setPermissionModal] = useState(false);
  const [copyText, setCopyText] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getSummary = async () => {
    try {
      if (!signal) {
        alert.show("Please enter signal");
        return;
      }
      setLoader(true);
      let payload = {
        signal,
      };

      const res = await api.generateSummary(payload);
      // console.log(res);
      if (res?.success) {
        setSummary(res?.summary || "");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText("Copied");
    setTimeout(() => {
      setCopyText("");
    }, 3000);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}

        <div className="row mx-0 drivers-row">
          <div className="col-12   ">
            <div className="d-flex justify-content-between pr-0 flex-wrap">
              <h4 className="color-dark fs-17 dib font-weight-bold mr-5 a-flex ai-center">
                Trade Summary
              </h4>
              <button className="themeBtn" onClick={handleShow}>
                Add Summary
              </button>
            </div>
            <div className="summaryMain">
              <div className="title">Please Enter Your Signal</div>
              <div className="mb-3">
                <textarea
                  name=""
                  id=""
                  onChange={(e) => setSignal(e.target.value)}
                  className="input"
                  rows={5}
                ></textarea>
              </div>

              {summary && (
                <div className="summaryText">
                  <span
                    onClick={() => handleCopy(summary)}
                    className="copyText"
                  >
                    <i className="fa-regular fa-copy me-2"></i>
                    {copyText}
                  </span>
                  <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                    {summary}
                  </ReactMarkdown>
                </div>
              )}

              <div className="mt-4">
                {loader ? (
                  <button className="themeBtn">AI is Analyzing...</button>
                ) : (
                  <button className="themeBtn" onClick={getSummary}>
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddSummary setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default TradeSummary;
